import { LOGIN_SUCCESSFUL,LOGOUT,CHANGED_PASSWORD   } from "../constants";
export const setLoginData = (payload) => {
  return (dispatch) => {
    dispatch({
      type: LOGIN_SUCCESSFUL,
      payload,
    });
  };
};

export const logout = () => {
  return (dispatch) => {
    dispatch({
      type: LOGOUT,
    });
  };
}


export const changePassword = () => {
  return (dispatch) => {
    dispatch({
      type: CHANGED_PASSWORD,
    });
  };
}
